<template>
    <div class="Background social-upload-page">
        <div class="page-header d-flex align-center justify-space-between">
            <div class="d-flex align-center">
                <h2 class="Title mb-0">
                    {{ $store.getters.t('social.upload.page.title') }}
                </h2>
            </div>
            <v-btn
                class="cta-btn"
                :disabled="!canUseSocialPublish"
                color="primary"
                depressed
            >
                <v-icon left>{{ canUseSocialPublish ? 'mdi-upload' : 'mdi-lock' }}</v-icon>
                {{ canUseSocialPublish ? uploadCtaLabel : lockedCtaLabel }}
            </v-btn>
        </div>

        <div class="upload-surface" :class="{ 'is-locked': !canUseSocialPublish }">
            <div v-if="!canUseSocialPublish" class="locked-panel text-center">
                <v-icon size="56" color="grey darken-1" class="mb-4">mdi-lock-outline</v-icon>
                <h3 class="mb-2">
                    {{ $store.getters.t('social.upload.locked.title') }}
                </h3>
                <p class="mb-4">
                    {{ $store.getters.t('social.upload.locked.description') }}
                </p>
                <v-btn class="locked-btn" disabled outlined>
                    <v-icon left>mdi-lock</v-icon>
                    {{ $store.getters.t('social.upload.locked.button') }}
                </v-btn>
            </div>
            <SocialUpload v-else />
        </div>
    </div>
</template>

<script>
import SocialUpload from '@/components/socialupload/SocialUpload.vue';

export default {
    components: {
        SocialUpload,
    },
    computed: {
        canUseSocialPublish() {
            return this.$store.getters['naviList/hasSocialPublish'];
        },
        uploadCtaLabel() {
            return this.$store.getters.t
                ? this.$store.getters.t('social.upload.cta.new')
                : '새 업로드';
        },
        lockedCtaLabel() {
            return this.$store.getters.t
                ? this.$store.getters.t('common.unlock_required')
                : '잠금 해제 필요';
        }
    },
};
</script>

<style scoped>
.social-upload-page {
    min-height: calc(100vh - 80px);
}
.upload-surface {
    position: relative;
}
.upload-surface.is-locked {
    border: 1px dashed #d1d5db;
    border-radius: 12px;
    padding: 48px 32px;
    background: #f5f6f8;
}
.locked-panel h3 {
    font-weight: 600;
    color: #111827;
}
.locked-panel p {
    color: #4b5563;
    line-height: 1.5;
}
.locked-btn {
    color: #4b5563;
    border-color: #cbd5f5;
}
.cta-btn {
    min-width: 160px;
}
</style>
